/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface JoinEntityDto
 */
export interface JoinEntityDto {

    /**
     * Identifier of the related entity
     *
     * @type {number}
     * @memberof JoinEntityDto
     * @example 1
     */
    id: number;
}
